import { Fragment } from "react";
import { Button } from "./Button";
import Chip from "./Chip";
import { TagContainer } from "./TagItems";
import { AvatarImage, PlayerImages } from "../components/AvatarImages";
import { FormListBox } from "./FormInput";

function ControllerHeroContainer({
  date_created,
  group_name,
  tags,
  createdBy,
  OpenGame = true,
  product,
  user,
}) {
  return (
    <Fragment>
      <div
        className="flex flex-row lg:flex-col justify-between col-span-2 lg:col-span-1 rounded-t lg:rounded-l lg:rounded-t-none h-60 lg:h-full w-auto bg-center bg-no-repeat bg-cover overflow-visible"
        style={{ backgroundImage: `URL('${product.game_image}')` }}
      >
        <div>
          <div className="mt-2 ml-2 mb-2 pt-2 inline-flex space-x-4">
            <Chip openGame={OpenGame} color="lime" text="Open Game" />
          </div>
          {user === createdBy ? (
            <div className="flex flex-col pl-2 pt-2 lg:hidden">
              <h1>{group_name}</h1>
              <h2>{product.name}</h2>
              <div className="flex pt-2 cursor-pointer space-x-4">
                <Button color="rose" description="Reset" />
                <Button color="emerald" description="Start" />
                <Button color="lightBlue" description="Advance" />
              </div>
            </div>
          ) : (
            <div className="flex flex-col content-evenly pl-2 pt-2 lg:hidden">
              <h1>{group_name}</h1>
              <h2>{product.name}</h2>
              <div className="flex cursor-pointer space-x-4">
                <div className="flex flex-col flex-1 mb-2">
                  <FormListBox
                    labelText="Region"
                    placeHolderText="Select Region"
                    value=""
                    name="formSelect"
                    onChange=""
                    multiple={false}
                    items={product.countries_list}
                  />
                </div>
                <div className="flex flex-col flex-1 mb-2">
                  <FormListBox
                    labelText="Role"
                    placeHolderText="Select Role"
                    value=""
                    name="formSelect"
                    onChange=""
                    multiple={false}
                    items={product.roles_list}
                  />
                </div>
                <div className="self-end mb-1.5">
                  <Button color="lightBlue" description="Join World" />
                </div>
              </div>
            </div>
          )}
        </div>
        <div className="flex lg:justify-start justify-end items-start">
          <TagContainer tags={tags} />
        </div>
      </div>
    </Fragment>
  );
}

function ControllerInfoContainer({
  date_created,
  group_name,
  createdBy,
  product,
  user,
}) {
  return (
    <Fragment>
      <div className="col-span-2 bg-coolGray-100 rounded-r-xl">
        <div className="flex flex-col lg:divide-y-4 lg:divide-coolGray-600 lg:divide-solid px-10">
          {user === createdBy ? (
            <div className="py-5 flex-1 justify-end hidden lg:block">
              <h1 className="text-right">{group_name}</h1>
              <h2 className="text-right capitalize">{product.name}</h2>
              <div className="flex justify-end pt-2 cursor-pointer space-x-4">
                <Button color="rose" description="Reset" />
                <Button color="emerald" description="Start" />
                <Button color="lightBlue" description="Advance" />
              </div>
            </div>
          ) : (
            <div className="py-5 flex-1 justify-end hidden lg:block">
              <h1 className="text-right">{group_name}</h1>
              <h2 className="text-right capitalize">{product.name}</h2>
              <div className="flex justify-end items-end cursor-pointer space-x-4">
                <div className="flex flex-col flex-1">
                  <FormListBox
                    labelText="Region"
                    placeHolderText="Select Region"
                    value=""
                    name="formSelect"
                    onChange=""
                    multiple={false}
                    items={product.countries_list}
                  />
                </div>
                <div className="flex flex-col flex-1">
                  <FormListBox
                    labelText="Role"
                    placeHolderText="Select Role"
                    value=""
                    name="formSelect"
                    onChange=""
                    multiple={false}
                    items={product.roles_list}
                  />
                </div>
                <Button color="lightBlue" description="Join World" />
              </div>
            </div>
          )}
          <div className="flex flex-col lg:flex-row py-5 flex-1 space-y-2 lg:space-x-24 lg:space-y-0 2xl:space-x-96 lg:divide-none divide-y-2 divide-coolGray-600">
            <div className="flex flex-initial">
              <div className="">
                <AvatarImage
                  image={`https://avatars.dicebear.com/api/jdenticon/${user}.svg?`}
                />
              </div>
              <div className="">
                <div className="pl-2 pt-2 text-coolGray-800">
                  Created by: <span className="font-semibold">{user}</span>
                </div>
                <div className="pl-2 pt-2 text-coolGray-800">
                  Created on:{" "}
                  <span className="font-semibold">{date_created}</span>
                </div>
              </div>
            </div>
            <div className="flex flex-col flex-1">
              <div className="flex flex-row justify-between">
                <div className="pl-2 pt-2 text-coolGray-800">Status:</div>
                <div className="self-center antialiased uppercase text-xs font-medium bg-teal-400 px-2 py-0.5 rounded">
                  Started
                </div>
              </div>
              <div className="flex flex-row justify-between">
                <div className="pl-2 pt-2 text-coolGray-800">Current Year:</div>
                <div className="self-center antialiased uppercase text-xs text-white font-medium bg-blueGray-500 px-2 py-0.5 rounded">
                  2017
                </div>
              </div>
              <div className="flex flex-row flex-wrap justify-between z-0">
                <div className="pl-2 pt-2 text-coolGray-800">
                  Players Joined:
                </div>
                {/* <PlayerImages images={images}/> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
}

function InvitationCardContent({ connected }) {
  return (
    <Fragment>
      <div className="flex flex-col lg:flex-row lg:justify-between space-y-2">
        <div className="lg:flex lg:items-center lg:space-x-4">
          <div className="">
            <AvatarImage
              image={`https://i.pravatar.cc/150?img=${
                Math.floor(Math.random() * 50) + 1
              }`}
            />
          </div>
          <div className="">
            <div className="font-bold text-teal-400 ">Joe Thomas</div>
            <div className="lg:flex lg:flex-row lg:divide-x-2 lg:divide-teal-400">
              <div className="font-semibold text-blueGray-500 lg:pr-1">
                Professor of Political Science
              </div>
              <div className="font-semibold text-blueGray-500 lg:pl-1">
                University of Texas at Austin
              </div>
            </div>
          </div>
        </div>
        <div className="flex space-x-4 lg:self-center">
          {!connected ? (
            <Fragment>
              <div className="text-blueGray-600 bg-teal-400 font-bold px-6 py-2 max-h-10 rounded uppercase">
                Accept
              </div>
              <div className="text-white bg-blueGray-500 font-bold px-6 py-2 max-h-10 rounded uppercase">
                Ignore
              </div>
            </Fragment>
          ) : (
            <Fragment>
              <div className="text-white bg-rose-500 font-bold px-6 py-2 max-h-10 rounded uppercase">
                Remove
              </div>
            </Fragment>
          )}
        </div>
      </div>
    </Fragment>
  );
}

export {
  ControllerHeroContainer,
  ControllerInfoContainer,
  InvitationCardContent,
};
